module.exports = __webpack_public_path__ + "img/gallery-02.c31cf5d5.jpg";